.shell {
  position: relative;
  z-index: 2;
  /* Scale the whole hub (greeting, tabs, cards) with the display via
   * zoom. --ui-scale is keyed to viewport HEIGHT, so the width cap must
   * be zoom-aware: dividing the 92vw cap by --ui-scale means the visual
   * (zoomed) width is min(1400px * scale, 92vw) — it grows toward a 4K
   * board, never overflows a tall/narrow window, and is a no-op at
   * 1080p. Caps at 1400px design so it doesn't sprawl on ultrawides.
   * Live pages are vw-fluid and deliberately NOT zoomed. */
  width: min(1400px, calc(92vw / var(--ui-scale)));
  margin: 0 auto;
  padding: clamp(24px, 5vw, 56px) clamp(20px, 4vw, 40px) 80px;
  font-family: var(--token-font-ui);
  color: var(--token-text-primary);
  zoom: var(--ui-scale);
}

.header {
  margin-bottom: 28px;
  text-align: center;
}

.greeting {
  font-family: var(--token-font-display);
  font-size: clamp(36px, 5vw, 56px);
  margin: 0 0 6px;
  color: #fefdf6;
  /* The fixed gradient scrim on .app::before darkens the upper band
   * so a clean white fill reads against any theme art. Shadows are
   * crisp + soft for depth, no stroke. */
  text-shadow:
    0 2px 4px rgba(8, 18, 12, 0.55),
    0 6px 20px rgba(8, 18, 12, 0.45);
  letter-spacing: 0.5px;
}

.name {
  color: var(--token-accent);
  text-shadow:
    0 2px 4px rgba(8, 18, 12, 0.55),
    0 6px 20px rgba(8, 18, 12, 0.45);
}

.subtitle {
  margin: 0;
  font-family: var(--token-font-body);
  color: rgba(255, 255, 255, 0.95);
  text-shadow:
    0 1px 4px rgba(8, 18, 12, 0.55),
    0 2px 10px rgba(8, 18, 12, 0.4);
  font-size: 16px;
  font-weight: 500;
}

.tabs {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  margin-bottom: 24px;
  border-radius: 999px;
}

.tab {
  flex: 0 0 auto;
  min-height: 40px;
  padding: 8px 22px;
  border-radius: 999px;
  border: none;
  background: transparent;
  /* Inactive tabs: dark text with a white halo so they stay legible
   * on whatever sits behind the glass strip (bright canopy, dark
   * leaves, sand, etc.). Active state inverts to white pill below. */
  color: var(--token-text-primary);
  text-shadow:
    0 1px 0 rgba(255, 255, 255, 0.65),
    0 0 8px rgba(255, 255, 255, 0.4);
  font-family: var(--token-font-ui);
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  transition:
    background 120ms ease,
    color 120ms ease;
}

.tab:hover {
  background: rgba(255, 255, 255, 0.32);
}

.tabActive {
  background: rgba(255, 255, 255, 0.95);
  color: #1f2933;
  text-shadow: none;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.9);
}

.logout {
  margin-left: auto;
  min-height: 40px;
  padding: 8px 18px;
  border-radius: 999px;
  border: 1px solid rgba(8, 18, 12, 0.18);
  background: rgba(255, 255, 255, 0.5);
  color: var(--token-text-primary);
  font-family: var(--token-font-ui);
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition:
    background 120ms ease,
    box-shadow 120ms ease;
}

.logout:hover {
  background: rgba(255, 255, 255, 0.78);
}

.body {
  display: block;
}
